import apiUrl from "../../../../utils/settings";

export const profilerUrl = () => {
  return apiUrl + '/profiler';
};

export const profilerLanguageUrl = () => {
  return apiUrl + '/profiler/preferred_language';
};
